import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const Img2 = () => {
  return (
    <StaticImage
      placeholder="blurred"
      src="../../../images/img_coll_2.png"
      alt="collar inteligente Kolyy"
    />
  );
};

export default Img2;
